import React from 'react'
import PropTypes from 'prop-types'
import ItemsGrid from 'atoms/ItemsGrid'
import WeekDay from './WeekDay'

export default function ScheduleEditorWeekDays(props) {
  const { weekDayItems, onItemAdd, addFormTitle, editFormTitle } = props
  const children = []
  for (let i = 1; i <= 7; i += 1) {
    const active = !!weekDayItems[i]
    children.push(
      <WeekDay
        key={i}
        weekDay={i}
        active={active}
        onItemAdd={onItemAdd}
        addFormTitle={addFormTitle}
        editFormTitle={editFormTitle}
      />
    )
  }

  return (
    <ItemsGrid>
      { children }
    </ItemsGrid>
  )
}

ScheduleEditorWeekDays.propTypes = {
  weekDayItems: PropTypes.object.isRequired,
  onItemAdd: PropTypes.func.isRequired,
  addFormTitle: PropTypes.string.isRequired,
  editFormTitle: PropTypes.string.isRequired,
}
